// extracted by mini-css-extract-plugin
export var falconContainer = "_ve-2";
export var offerCenter = "_ve-0";
export var roktContainer = "_ve-1";